import { useQuery } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { showSwalAlert } from "../components/showSwalAlert";
import apiServices from "../ApiServices/request-handler";

const fetchProjectList = async ({ queryKey }) => {
  const [, projectId] = queryKey;
  const response = await apiServices.getSingleProject(projectId);
  return response.data;
};

export const useProject = (projectId) => {
  return useQuery({
    queryKey: ["singleProjectList", projectId], // ✅ fixed typo
    queryFn: fetchProjectList,
    enabled: !!projectId, // ✅ only fetch if projectId is valid
  });
};

export const NextProject = (
  setLoadingToapi,
  setMaterialStatusReport,
  setCostingStatusReport,
  navigate,
  projectID
) => {
  return useMutation({
    mutationFn: async (nextProjectData) => {
      const response = await apiServices.nextProject(
        projectID,
        nextProjectData
      );
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingToapi(false);
      if (
        data?.data?.materialReportStatus === "IN_PROGRESS" ||
        data?.data?.materialReportStatus === "IN PROGRESS"
      ) {
        setMaterialStatusReport(data?.data?.materialReportStatus);
      }
      if (
        data?.data?.costingReportStatus === "IN_PROGRESS" ||
        data?.data?.costingReportStatus === "IN PROGRESS"
      ) {
        setCostingStatusReport(data?.data?.costingReportStatus);
      }
      navigate("/status");
      showSwalAlert("", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};

export const useCreateMaterialReportMutation = (
  setLoadingToapi,
  setMaterialStatusReport,
  setCostingStatusReport,
  navigate
) => {
  return useMutation({
    mutationFn: async (createMaterialData) => {
      const response = await apiServices.createMaterialReport(
        createMaterialData
      );
      return response.data;
    },
    onSuccess: (data) => {
      setLoadingToapi(false);
      if (
        data?.data?.materialReportStatus === "IN_PROGRESS" ||
        data?.data?.materialReportStatus === "IN PROGRESS"
      ) {
        setMaterialStatusReport(data?.data?.materialReportStatus);
      }
      if (
        data?.data?.costingReportStatus === "IN_PROGRESS" ||
        data?.data?.costingReportStatus === "IN PROGRESS"
      ) {
        setCostingStatusReport(data?.data?.costingReportStatus);
      }
      navigate("/status");
      showSwalAlert("", data?.message, "success");
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoadingToapi(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};

const fetchMaterialPriceingRange = async () => {
  const response = await apiServices.materialPriceingRange({
    page: 1,
    limit: 1000,
  });
  return response.data;
};

export const useMaterialPriceingRange = () => {
  return useQuery({
    queryKey: ["materialPriceingRange"], // ✅ fixed typo
    queryFn: fetchMaterialPriceingRange,
    // enabled: !!projectId, // ✅ only fetch if projectId is valid
  });
};

export const useSaveCostingReportMutation = (
  projectID,
  setLoading,
  setCostingReport,
  setCostingStatusReport
) => {
  return useMutation({
    mutationFn: async (saveCostingReportData) => {
      const response = await apiServices.saveCostingReport(
        projectID,
        saveCostingReportData
      );
      return response.data;
    },
    onSuccess: (data) => {
      setLoading(false);
      showSwalAlert("", data?.message, "success");
      setCostingReport(JSON.parse(data?.data?.costingReport));
      setCostingStatusReport(data?.data?.costingReportStatus);
    },
    onError: (error) => {
      const message = error.response
        ? error.response.data.message
        : error.message;
      setLoading(false);
      showSwalAlert("Oops...", message, "error");
    },
  });
};
